/** Sending domain management GraphQL operations (TRK-6050). Result types are inferred from selection sets. */

import { graphql } from 'app/generated/gql'

export const SENDING_DOMAINS_QUERY = graphql(`
  query SendingDomains($search: String, $pagination: PaginationInput, $sort: SortInput) {
    sendingDomains(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        id
        orgId
        workspaceId
        domain
        type
        status
        dnsRecords {
          type
          name
          value
          found
        }
        createdDate
        updatedDate
      }
      total
      page
    }
  }
`)

export const CREATE_SENDING_DOMAIN_MUTATION = graphql(`
  mutation CreateSendingDomain($input: CreateSendingDomainInput!) {
    createSendingDomain(input: $input) {
      id
      domain
      type
      status
      dnsRecords {
        type
        name
        value
        found
      }
      createdDate
    }
  }
`)

export const VERIFY_SENDING_DOMAIN_MUTATION = graphql(`
  mutation VerifySendingDomain($id: ID!) {
    verifySendingDomain(id: $id) {
      id
      status
      dnsRecords {
        type
        name
        value
        found
      }
      updatedDate
    }
  }
`)

export const DELETE_SENDING_DOMAIN_MUTATION = graphql(`
  mutation DeleteSendingDomain($id: ID!) {
    deleteSendingDomain(id: $id)
  }
`)
